import React from 'react';
import 'react-phone-number-input/style.css'
import PhoneInput, {isPossiblePhoneNumber} from 'react-phone-number-input'
import { Full as Loader } from '../components/loaders/full';
import {Config} from "../app.config";
import { withTranslation } from "react-i18next";


class RegistrationDetails extends React.Component {

    constructor() {
        super();
        this.state = {
            phoneNumber: '', // Initialize phoneNumber state
            firstName: '',
            lastName: '',
        };
        this.on = {
            phoneChange: (value) => {
                this.setState({ phoneNumber: value });
            },
            firstNameChange: (e) => {
                this.setState({ firstName: e.target.value });
            },
            lastNameChange: (e) => {
                this.setState({ lastName: e.target.value });
            },
            change: () => {
                const name = `${this.state.firstName.trim()} ${this.state.lastName.trim()}`.trim();
                const email = document.getElementById('email-input').value;

                const isIsraeli = this.state.phoneNumber && this.state.phoneNumber.startsWith('+972');
                if (!isIsraeli) {
                    if (typeof this.props.onChange === "function") {
                        this.props.onChange(name, email, this.state.phoneNumber);
                    }
                    return;
                }

                this.setState({ loader: true });
                    const data = {
                        phone: this.state.phoneNumber
                    }
                    const myHeaders = new Headers();
                    myHeaders.append("Content-Type", "application/json");
                    fetch(Config.routes.sendSMSCods, {
                        method: 'post',
                        headers: myHeaders,
                        body: JSON.stringify(data)
                    }).then((res) => {
                        this.setState({
                            loader: false,
                        })
                        if (res.status === 200) {
                            if(typeof this.props.onChange === "function"){
                                this.props.onChange(name, email, this.state.phoneNumber);
                            }
                        } else {
                            return res.json();
                        }
                    }, (result) => {
                        if (result && typeof result.msg === "string") {
                            this.setState({
                                msg: result.msg
                            })
                        }
                    }).then(result => {
                        if (result && typeof result.msg === "string") {
                            this.setState({
                                msg: result.msg
                            })
                        }
                    })
                }
            }
        }

    render() {
        const { t, i18n } = this.props;
        const { phoneNumber, firstName, lastName, msg, loader } = this.state;
        const isPhoneNumber = phoneNumber && isPossiblePhoneNumber(phoneNumber);
        const isIsraeli = phoneNumber && phoneNumber.startsWith('+972');
        const isNameValid = firstName.trim() !== "" && lastName.trim() !== "";

        // Set default country dynamically based on language
        const defaultCountry = i18n.language === "he" ? "IL" : "US";

        return (
            <section className="z-10 text-gray-700 body-font">
                <div className="relative z-10 container">
                    <div className="z-10 xl:w-12/12 lg:w-12/12 w-full mx-auto text-center">
                        <h2 className="w-full my-2 text-2xl font-bold leading-tight text-center text-gray-800">
                            {t("registration_form_title")}
                        </h2>
                        <div className="w-full mb-4">
                            <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
                        </div>
                        <div className="leading-relaxed text-lg text-center">
                            <label htmlFor="first-name-input" className="block text-left">
                                {t("first_name")}
                            </label>
                            <input
                                type="text"
                                id="first-name-input"
                                placeholder={t("first_name_placeholder")}
                                value={firstName}
                                onChange={this.on.firstNameChange}
                                className="border border-gray-300 focus:outline-none focus:border-blue-500 rounded-md py-2 px-4 mt-2 w-full"
                            />
                            <br />
                            <label htmlFor="last-name-input" className="block mt-4 text-left">
                                {t("last_name")}
                            </label>
                            <input
                                type="text"
                                id="last-name-input"
                                placeholder={t("last_name_placeholder")}
                                value={lastName}
                                onChange={this.on.lastNameChange}
                                className="border border-gray-300 focus:outline-none focus:border-blue-500 rounded-md py-2 px-4 mt-2 w-full"
                            />
                            <br />
                            <label htmlFor="email-input" className="block mt-4 text-left">
                                {t("email")}
                            </label>
                            <input
                                type="email"
                                id="email-input"
                                placeholder={t("email_placeholder")}
                                className="border border-gray-300 focus:outline-none focus:border-blue-500 rounded-md py-2 px-4 mt-2 w-full"
                            />
                            <br />
                            <label htmlFor="phone-number-input" className="block mt-4 text-left">
                                {t("phone_number")}
                            </label>
                            <PhoneInput
                                international
                                defaultCountry={defaultCountry}
                                placeholder={t("phone_placeholder")}
                                value={phoneNumber}
                                onChange={this.on.phoneChange}
                            />
                            <br />
                            <button
                                className={`flashing text-white bg-blue-900 border-0 mt-5 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg ${
                                    !isPhoneNumber || !isNameValid ? "opacity-50 cursor-not-allowed" : ""
                                }`}
                                onClick={this.on.change}
                                disabled={!isPhoneNumber || !isNameValid} // Disable until name fields and phone are valid
                            >
                                {isIsraeli ? t("send_activation_code") : t("btn_next")}
                            </button>
                        </div>
                    </div>
                    <br />
                    {msg ? (
                        <h1 style={{ color: "red" }} className="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
                            {t("error")}: {msg}
                        </h1>
                    ) : null}
                </div>
                {loader ? <Loader loaderText={t("send_activation_code")} /> : null}
            </section>
        );
    }
}

// Wrap component with `withTranslation()` for class components
export default withTranslation()(RegistrationDetails);
